export const filterLabels = {
  code: "code",
  codeId: "codeID",
  createdAt: "generatedOn",
  usedByMemberId: "memberID",
  status: "status",
  used: "used",
  unused: "unused",
  usedAt: "usedOn",
};

export const redemptionCodesFilterLabelsList = Object.keys(filterLabels).map(
  (key) => ({
    id: key,
    label: filterLabels[key as keyof typeof filterLabels],
  }),
);
